import { UniqueIdentifier } from '@dnd-kit/core';
import React from 'react';

import { Stack, Text } from '@eluve/components';
import { GroupBlock } from '@eluve/llm-outputs';

import { BlockPicker } from '../BlockPicker';
import { AsBuilderBlock } from '../utilities';

export interface GroupBlockControlProps {
  parentId: UniqueIdentifier | null;
  group: AsBuilderBlock<GroupBlock>;
}

export const GroupBlockControl: React.FC<GroupBlockControlProps> = ({
  group,
}) => {
  return (
    <Stack gap={3} direction="horizontal">
      <Text inline className="text-nowrap">
        Add
      </Text>
      <BlockPicker parentId={group.id} />
    </Stack>
  );
};
